import { useContext, useMemo } from 'react';
import { CopyLinkButton, useAppHeaderAction } from '@/core/deep-dive/export';
import { LocalWidgetRouterContext } from '@/core/widgets/export';
import { emptyMapUrlState, MapUrlState, mapShareUrl } from '@/modules/pipelines/data/map-url-state';

export default function useCopyLinkAction(state: MapUrlState = emptyMapUrlState) {
  const localRouter = useContext(LocalWidgetRouterContext);

  const href = useMemo(
    () =>
      mapShareUrl(
        state,
        window.location,
        localRouter?.basePath ?? 'pipeline-map',
        localRouter?.path,
      ),
    [state, localRouter],
  );

  useAppHeaderAction(useMemo(() => <CopyLinkButton href={href} />, [href]));
}
